import { connect } from 'react-redux';
import StickyAlert from './StickyAlert';
import { getAlertType, getAlertMessage, getAlertShow } from 'store/alert/selectors';

const mapStateToProps = (state) => ({
  type: getAlertType(state),
  message: getAlertMessage(state),
  show: getAlertShow(state),
});

export default connect(mapStateToProps)(StickyAlert);
